{
  "next": "다음",
  "previous": "이전"
}
